import { gql } from 'graphql-tag'

export const GET_EVENT = gql`
  query getEvent($eventSlug: String!, $settingSlug: String, $tid: String) {
    eventBySlug(eventSlug: $eventSlug, settingSlug: $settingSlug, tid: $tid) {
      name
      slug
      checkInDate
      checkOutDate
      eventDateFrom
      eventDateTo
      latitude
      longitude
      venueDescription
      venueName
      logoPicture
      markerPicture
      setting {
        organizationId
        colorPrimary
        colorSecondary
        colorHotelMarkerPrimary
        colorHotelMarkerSecondary
        hideHotline
        hideAddressAutocompleteInput
        name
        slug
        mapMarkers {
          description
          latitude
          longitude
          markerPicture
          name
        }
      }
    }
  }
`
